import React, { useEffect, useState } from "react";
import { Header } from "../header";
import StrategyBuilder from "../StrategyBuilder";
import "./index.css";
import "./quote.css";

export function Layout() {
  return (
    <div>
      <Header showMenu={false}></Header>
      <StrategyBuilder />
      <div className="blockquote">
        <p>
          <b>Disclaimer :</b> Actual profit or loss may vary depending upon
          taxes, charges, etc
        </p>
      </div>
     
    </div>
  );
}
